export enum BranchJourneys {
  GET_MY_FULL_SHOP = "646e60ff5d8b8d0001b9ac50",
  BETTER_IN_APP = "6363ea8d74a1710001c863b4",
}
